<template>
    <div class="brand-banner">
        <div class="background">
            <img class="background-image" :src="backgroundSrc" :alt="backgroundAlt">
        </div>
        <div class="logo-container">
            <div class="logo">
                <div class="overlay">
                    <img src="/images/brand-logo-bg-offset.svg" alt="">
                </div>
                <div :class="['logo-clip', logoClass]">
                    <img :src="logoSrc" :alt="logoAlt">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BrandBanner",
    props: {
        backgroundSrc: {
            type: String,
            required: true
        },
        backgroundAlt: {
            type: String,
            default: "brand background"
        },
        logoSrc: {
            type: String,
            required: true
        },
        logoAlt: {
            type: String,
            default: "brand logo"
        },
        logoClass: {
            type: String,
            default: ""
        },
        overlayColor: {
            type: String,
            default: "black"
        },
        overlayOpacity: {
            type: Number,
            default: 0.75
        }
    },
    computed: {
        overlayStyle() {
            return {
                background: this.overlayColor,
                opacity: this.overlayOpacity
            };
        }
    }
};

</script>

<style scoped lang="scss">
.brand-banner {
    position: relative;
    width: 100%;
    height: 35vw;
    min-height: 200px;
    max-height: 400px;
    overflow: hidden;

    .background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 0;

        .background-image {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }


    }

    .logo-container {
        position: relative;
        z-index: 1;
        width: 100%;
        height: 100%;
        max-width: 1380px;
        margin: 0 auto;
        box-sizing: border-box;
        padding-left: 24px;

        .logo {
            position: relative;
            --overlay-width: max(420px, 38vw);
            --logo-area-width: max(260px, 22vw);
            width: 260px;
            max-width: calc(100vw - 24px);
            height: 100%;
            z-index: 2;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            @media (max-width: 767px) {
                --overlay-width: 340px;
                --logo-area-width: 150px;
            }



            .overlay {
                position: absolute;
                width: 100%;
                height: 100%;
                z-index: -1;
                right: -140px;

                @media (max-width: 767px) {
                    right: 15%;
                }

                img {
                    height: 540px;
                    opacity: 0.75;

                }

                &::before {
                    position: absolute;
                    right: 100%;
                    top: 0;
                    width: 60vw;
                    height: 100%;
                    background: black;
                    opacity: 0.75;
                    content: "";
                    z-index: -1;
                }

            }

            .logo-clip {
                position: relative;
                width: var(--logo-area-width);
                height: 100%;
                box-sizing: border-box;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                
                img {
                    display: block;
                    height: auto;
                    max-height: 100px;
                    
                }

                &.logo-wide {
                    img {
                        max-height: 180px;
                    }
                }
            }
        }
    }
}
</style>